export const feedbackData = {
  emptyFeedback: {
    overviewId: "",
    player: {
      q1: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q2: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q3: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q4: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
    },
    objectives: {
      q1: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q2: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q3: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q4: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
    },
    kpi: {
      q1: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q2: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q3: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q4: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
    },
    initiatives: {
      q1: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q2: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q3: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q4: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
    },
    actions_activities_and_processes: {
      q1: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q2: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q3: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q4: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
    },
    culture: {
      q1: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q2: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q3: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
      q4: {
        total_rating: 0,
        possible_rating: 0,
        player: "A",
      },
    },
    quarter_visibility: {
      q1: true,
      q2: false,
      q3: true,
      q4: true,
    },
  },
  totalResultData: [
    {
      key: "1",
      name: "Player",
      firstQuater: "D-player",
      secondQuater: "C-player",
      thirdQuater: "A-player",
      fourthQuater: "B-player",
    },
    {
      key: "2",
      name: "Total",
      firstQuater: "7.0 / 10",
      secondQuater: "12.6 / 15",
      thirdQuater: "8.1 / 10",
      fourthQuater: "10.5 / 15",
    },
    {
      key: "3",
      name: "Objectives",
      firstQuater: "2.5 / 5",
      secondQuater: "4.1 / 5",
      thirdQuater: "2.5 / 5",
      fourthQuater: "2.8 / 5",
    },
    {
      key: "4",
      name: "KPIs",
      firstQuater: "2.1 / 5",
      secondQuater: "3.9 / 5",
      thirdQuater: "3.1 / 5",
      fourthQuater: "3.5 / 5",
    },
    {
      key: "5",
      name: "Initiatives",
      firstQuater: "2.4 / 5",
      secondQuater: "4.6 / 5",
      thirdQuater: "2.5 / 5",
      fourthQuater: "2.8 / 5",
    },
    {
      key: "6",
      name: "Actions, Activities & Proc",
      firstQuater: "2.4 / 5",
      secondQuater: "4.6 / 5",
      thirdQuater: "2.5 / 5",
      fourthQuater: "2.8 / 5",
    },
    {
      key: "7",
      name: "Culture",
      firstQuater: "2.4 / 5",
      secondQuater: "4.6 / 5",
      thirdQuater: "2.5 / 5",
      fourthQuater: "2.8 / 5",
    },
  ],
  objectiveData: [
    {
      key: "1",
      statement: "Shows a high level of commitment in pursuing objectives.",
      score: "4",
    },
    {
      key: "2",
      statement:
        "Has achieved the defined objectives within the given time frame.",
      score: "3",
    },
  ],
  kpiData: [
    {
      key: "1",
      principle: "Knows their KPIs and the factors influencing them.",
      score: "4",
    },
    {
      key: "2",
      principle: "Has achieved the set target values for the KPIs.",
      score: "3",
    },
    {
      key: "3",
      principle: "Strives continuously to improve the KPI",
      score: "2",
    },
  ],
  initiativesData: [
    {
      key: "1",
      principle: "Drives initiatives reliably and independently.",
      score: "4",
    },
    {
      key: "2",
      principle:
        "Effectively engages initiative contributors to ensure they fulfill their part.",
      score: "3",
    },
  ],
  actionsActivitiesProcessData: [
    {
      key: "1",
      principle: "Prioritizes the right actions and completes them.",
      score: "3",
    },
    {
      key: "2",
      principle:
        "Completes recurring activities thoroughly and with high quality.",
      score: "2",
    },
    {
      key: "3",
      principle: "Has sufficiently detailed all relevant processes.",
      score: "4",
    },
    {
      key: "4",
      principle: "Has aligned the processes with the involved parties.",
      score: "3",
    },
    {
      key: "5",
      principle: "The processes are properly implemented and adhered to.",
      score: "4",
    },
    {
      key: "6",
      principle: "Strives continuously to improve the processes.",
      score: "2",
    },
  ],
  cultureFitData: [
    {
      key: "1",
      principle:
        "Strongly identifies with the company's culture and values & principles.",
      score: "4",
    },
    {
      key: "2",
      principle: "Consistently lives the company's values & principles.",
      score: "3",
    },
  ],
};
